var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrentPlanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.5,
    height: 16.5,
    viewBox: "0 0 13.5 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Currrent_plans_details",
    "data-name": "Currrent plans details",
    transform: "translate(-637.25 -2299.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "reader-outline_2_",
    "data-name": "reader-outline (2)",
    transform: "translate(638.165 2300.384)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_849",
    "data-name": "Rectangle 849",
    width: 12,
    height: 15,
    rx: 2,
    transform: "translate(-0.165 -0.384)",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M176,128h5.792M176,130.9h5.792m-5.792,2.9h2.9",
    transform: "translate(-173.104 -125.186)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentPlanIcon);
export default __webpack_public_path__ + "static/media/current-plan-icon.ba37fc169024e782ea44c20325103dbf.svg";
export { ForwardRef as ReactComponent };